<template>
	<Layout :loading="loading || saving" :pageTitle="title">
		<template #cta>
			<!-- <div @click="save" class="btn btn-success">Crear</div> -->
		</template>

		<FormulateForm v-model="form" ref="form" @submit="save" style="max-width:100%">
			<div class="main-container container" v-if="!loading">
				<div class="row row-xs mt-4">
					<div class="col-12">
						<div class="card">
							<div class="card-body">
								<FormulateInput
									label="Pregunta"
									name="question"
									validation-name="Pregunta"
									validation="required"
									:help="lang != 'es' ? 'Pregunta original: ' + item.question : ''"
								/>

								<FormulateInput
									type="wysiwyg"
									name="answer"
									label="Respuesta"
									validation="required"
									validation-name="Respuesta"
									:showMenuBar="true"
									:height="400"
								/>

								<div class="d-flex justify-content-between mt-4">
									<FormulateInput type="button" data-ghost @click="$router.go(-1)">Cancelar</FormulateInput>
									<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
									<FormulateInput type="submit" :label="title" v-else />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>
	</Layout>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'

export default {
	name: 'FaqForm',
	mixins: [mixins],
	data() {
		return {
			title: 'Crear pregunta',
			action: 'create',
			form: {
				question: '',
				answer: '',
			},
			item: {},
			loading: false,
			saving: false,
		}
	},
	beforeMount() {
		if (this.$route.params.id) {
			this.action = 'update'
			this.load()
		}
	},
	methods: {
		save() {
			this.saving = true
			let dataInput = {
				lang: this.lang,
				question: this.form.question,
				answer: this.form.answer,
			}
			if (this.action == 'create') {
				this.create(dataInput)
			}
			if (this.action == 'update') {
				this.update(dataInput)
			}
		},
		create(data) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: FaqInput!) {
							faqCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data,
					},
				})
				.then(() => {
					this.$toast.success('Pregunta creada correctamente')
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},
		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: FaqInput!) {
							faqUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.$route.params.id,
						data: dataInput,
					},
				})
				.then(() => {
					this.$toast.success('Pregunta editada correctamente')
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							faq(id: $id) {
								id
								question
								answer
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.form = data.faq

					this.title = `Editar pregunta`
					this.loading = false
				})
				.catch(() => {
					this.$toast.success('El item que desea editar no existe')
					this.$router.go(-1)
				})
		},
	},
}
</script>

<style scoped>
.card-body /deep/ .formulate-form {
	max-width: 100%;
}
</style>
